import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface TranslateProps {
  path: string;
}

export const Translate = ({ path }: TranslateProps): ReactElement => {
  const { t } = useTranslation();
  return <>{t(path)}</>;
};
